import React from 'react';

const AssignedPerson = ({ name, image }) => {
  return (
    <div className="flex items-center gap-2">
      <img src={image} alt="avatar" className="team-avater" />
      <p className="lws-task-assignedOn">{name}</p>
    </div>
  );
};

export default AssignedPerson;
